'use strict';

angular.module('amexReconciliationApp')
  .component('transactionDetailsDataPanel', {
    templateUrl: 'scripts/views/components/transaction-details-data-panel.html',
    bindings: {
      taxes: '<'
    },
    controller: function ($scope,
                          $translate,
                          ActiveTransactionModel,
                          TransactionsModel,
                          SiteConfigModel,
                          TransactionSearchModel,
                          UserModel,
                          ExceptionNoteTranslationService,
                          TransactionDetailsRepository) {
      var self = this;

      self.exceptionCodes = {};
      self.getCurrencyFormat = UserModel.getCurrencyFormat;

      ActiveTransactionModel.onActiveTransactionChanged($scope, resetForm);

      self.isExceptionEditable = function () {
        return !(ActiveTransactionModel.activeTransactionIsFullyLocked() ||
            TransactionSearchModel.isLimitedRole() ||
            !SiteConfigModel.clearExceptionOn());
      };

      self.displayLocalCurrency = function () {
        return !_.isEqual(_.get(self.transaction, 'details.billedCurrency'), _.get(self.transaction, 'details.localCurrency'));
      };

      self.cancelTransactionDetails = function () {
        resetTransactionDetailSaveFlags();
        resetForm(ActiveTransactionModel.activeTransaction());
        setPristine();
      };

      self.$onInit = function () {
        resetTransactionDetailSaveFlags();
        resetForm(ActiveTransactionModel.activeTransaction());
      };

      self.saveTransactionDetails = function () {
        self.transactionDetailsSaveSuccessful = false;
        self.transactionDetailsSaveUnsuccessful = false;

        var transaction = ActiveTransactionModel.activeTransaction();
        var transactionId = transaction.id;

        var update = {
          id: transactionId,
          exceptionNote: ExceptionNoteTranslationService.encodeExceptionNote(self.exceptionNote, self.exceptionCodes),
          estimatedTaxes: self.transactionTaxes
        };

        TransactionDetailsRepository.update(update)
          .then(function () {
            return TransactionsModel.refreshTransactions([transactionId])
              .then(onDetailsSavedSuccess);
          })
          .catch(onDetailsSavedFailure);
      };

      self.areCancelAndSaveEnabled = formIsPristine;

      self.isTaxComponentDisabled = function () {
        if(TransactionSearchModel.isLimitedRole()) {
          return true;
        }

        if(ActiveTransactionModel.activeTransactionIsFullyLocked()) {
          return true;
        }

        if(ActiveTransactionModel.activeTransactionIsPartiallyLocked() &&
          SiteConfigModel.siteConfig().partialLockOptions.estimatedTaxLocked) {
          return true;
        }

        return false;
      };

      function onDetailsSavedSuccess() {
        self.transactionDetailsSaveUnsuccessful = false;
        self.transactionDetailsSaveSuccessful = true;
        self.taxes = _.cloneDeep(self.transactionTaxes);
        setPristine();
      }

      function onDetailsSavedFailure() {
        self.transactionDetailsSaveUnsuccessful = true;
        self.transactionDetailsSaveSuccessful = false;
      }

      function resetTransactionDetailSaveFlags() {
        self.transactionDetailsSaveSuccessful = false;
        self.transactionDetailsSaveUnsuccessful = false;
      }

      function resetForm(transaction) {
        self.transaction = transaction;
        self.transactionTaxes = _.cloneDeep(self.taxes);
        self.exceptionNote = ExceptionNoteTranslationService
          .translateExceptionNote(_.get(transaction, 'details.exceptionNote', ''), self.exceptionCodes);
      }

      function formIsPristine() {
        return _.get(self.form,'$pristine');
      }

      function setPristine() {
        self.form.$setPristine();
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionDetailsDataPanel.js
// module id = 485
// module chunks = 0